import { useMemo } from 'react';

import { FieldStateKey, PermissionKey } from '@/common/constants';
import useGetPermissionToEditOverridableField from '@/modules/user/hooks/useGetPermissionToEditOverridableField';

const useGetAllowRenewalsFieldsPermProps = () => {
  const allowRenewalsPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.ALLOW_RENEWALS,
    FieldStateKey.ALLOW_RENEWALS
  );

  const hasFields = useMemo(() => [
    allowRenewalsPermProps,
  ].some((item) => !item.isAbsent), [
    allowRenewalsPermProps,
  ]);

  return {
    allowRenewalsPermProps,
    hasFields,
  };
};

export default useGetAllowRenewalsFieldsPermProps;
